import { v4 as uuidv4 } from 'uuid'

export const generateIdFromString = (str?: string) => {
  if (!str) {
    return uuidv4()
  }

  return str.toLowerCase().replace(/ /g, '_')
}
